// API base URL - change REACT_APP_API_BASE for WordPress deployment
// Development: /api (proxied to FastAPI)
// WordPress:   /wp-json/rmd/v1
export const API = process.env.REACT_APP_API_BASE || `${process.env.REACT_APP_BACKEND_URL}/api`;
